module.exports = __webpack_public_path__ + "img/logo_th.066fdb3e.svg";